import { setupInfiniteScroll, setupGenericSearch } from '../../utils/common.js';

/**
 * Módulo de Serviços
 * Responsável por funcionalidades relacionadas a serviços e produtos
 */

// Importar funcionalidades do formulário de serviços
import './service-form.js';

// Inicialização da listagem de serviços
$(document).ready(function() {
    // Listagem com scroll infinito
    let pagination;
    if ($('.tbodyServices').length) {
        pagination = setupInfiniteScroll('.tbodyServices', '/servicos', '#currentPage');
    }

    // Funcionalidade de busca
    if ($('#searchService').length) {
        setupGenericSearch(
            '#searchService',
            '/servicos/search',
            '.table-services',
            '.tbodyServices',
            // Sem filtros extras por enquanto
            () => ({})
        );
    }

    // Sincronizar paginação com resultados da busca
    $(document).on('search:success', function(e, response, searchData) {
        if (pagination) {
            pagination.config.loadUrl = window.location.pathname;
            pagination.config.extraParams = searchData;
            pagination.reset();
        }
    });
});

/**
 * Carrega dados de serviços via AJAX
 */
export function loadServicesData() {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: "/servicos/data",
            type: "GET",
            success: function (response) {
                if (response && response.data) {
                    resolve(response.data);
                } else {
                    reject(new Error("Dados de serviços não encontrados"));
                }
            },
            error: function (xhr, status, error) {
                reject(error);
            },
        });
    });
}

/**
 * Inicializa select de serviços com dados carregados
 * @param {jQuery} selectElement - Elemento select a ser inicializado
 */
export function initServiceSelect(selectElement) {
    if (!selectElement || selectElement.length === 0) {
        return;
    }

    // Verificar se o select já tem Select2 inicializado (evitar conflitos)
    if (selectElement.hasClass('select2-hidden-accessible') || selectElement.attr('data-protected') === 'true') {
        return;
    }

    // Verificar se o select tem opções preservadas (para edição)
    const hasPreservedOptions = selectElement.find('option[data-preserve="true"]').length > 0;
    if (hasPreservedOptions) {
        return;
    }

    loadServicesData()
        .then((services) => {
            // Limpa opções existentes exceto a primeira (placeholder)
            selectElement.find('option:not(:first)').remove();
            
            // Adiciona opções de serviços
            services.forEach((service) => {
                const option = $('<option></option>')
                    .attr('value', service.id)
                    .attr('data-price', service.price)
                    .attr('data-description', service.description)
                    .text(`${service.name} - R$ ${service.price}`);
                
                selectElement.append(option);
            });
            
            // Inicializa eventos do select
            initServiceSelectEvents(selectElement);
        })
        .catch((error) => {
            // Adiciona opção de erro
            selectElement.append(
                $('<option></option>')
                    .attr('value', '')
                    .attr('disabled', true)
                    .text('Erro ao carregar serviços')
            );
        });
}

/**
 * Inicializa eventos do select de serviços
 * @param {jQuery} selectElement - Elemento select
 */
function initServiceSelectEvents(selectElement) {
    selectElement.on('change', function() {
        const selectedOption = $(this).find('option:selected');
        const serviceId = selectedOption.val();
        const servicePrice = selectedOption.data('price');
        const serviceDescription = selectedOption.data('description');
        
        if (serviceId) {
            // Dispara evento customizado com dados do serviço
            $(this).trigger('serviceSelected', {
                id: serviceId,
                price: servicePrice,
                description: serviceDescription,
                name: selectedOption.text()
            });
        }
    });
}

/**
 * Carrega dados de produtos via AJAX
 */
export function loadProductsData() {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: "/produtos/data",
            type: "GET",
            success: function (response) {
                if (response && response.data) {
                    resolve(response.data);
                } else {
                    reject(new Error("Dados de produtos não encontrados"));
                }
            },
            error: function (xhr, status, error) {
                reject(error);
            },
        });
    });
}

/**
 * Inicializa select de produtos com dados carregados
 * @param {jQuery} selectElement - Elemento select a ser inicializado
 */
export function initProductSelect(selectElement) {
    if (!selectElement || selectElement.length === 0) {
        return;
    }

    loadProductsData()
        .then((products) => {
            // Limpa opções existentes exceto a primeira (placeholder)
            selectElement.find('option:not(:first)').remove();
            
            // Adiciona opções de produtos
            products.forEach((product) => {
                const option = $('<option></option>')
                    .attr('value', product.id)
                    .attr('data-price', product.price)
                    .attr('data-stock', product.stock)
                    .attr('data-description', product.description)
                    .text(`${product.name} - R$ ${product.price}`);
                
                selectElement.append(option);
            });
            
            // Inicializa eventos do select
            initProductSelectEvents(selectElement);
        })
        .catch((error) => {
            // Adiciona opção de erro
            selectElement.append(
                $('<option></option>')
                    .attr('value', '')
                    .attr('disabled', true)
                    .text('Erro ao carregar produtos')
            );
        });
}

/**
 * Inicializa eventos do select de produtos
 * @param {jQuery} selectElement - Elemento select
 */
function initProductSelectEvents(selectElement) {
    selectElement.on('change', function() {
        const selectedOption = $(this).find('option:selected');
        const productId = selectedOption.val();
        const productPrice = selectedOption.data('price');
        const productStock = selectedOption.data('stock');
        const productDescription = selectedOption.data('description');
        
        if (productId) {
            // Dispara evento customizado com dados do produto
            $(this).trigger('productSelected', {
                id: productId,
                price: productPrice,
                stock: productStock,
                description: productDescription,
                name: selectedOption.text()
            });
        }
    });
}

/**
 * Inicializa todos os selects de serviços na página
 */
export function initAllServiceSelects() {
    $('.service-select').each(function() {
        initServiceSelect($(this));
    });
}

/**
 * Inicializa todos os selects de produtos na página
 */
export function initAllProductSelects() {
    $('.product-select').each(function() {
        initProductSelect($(this));
    });
}

/**
 * Inicializa módulo de serviços
 */
export function initServicesModule() {
    $(document).ready(function() {
        initAllServiceSelects();
        initAllProductSelects();
    });
}